import React from "react";
import Reveal from "./Reveal";

/**
 * How It Works — 3 giant chapters, alternating left/right, each with
 * a phone screenshot companion. Apple Fitness+ style: bold numbers,
 * massive typography, plenty of breathing room.
 */
const HOW_IT_WORKS = [
  {
    step: 1,
    title: "Set your goals",
    description:
      "Choose your goals, experience level and equipment. Give your coach the starting point for your training plan.",
    highlight: "Built around your goals",
    image: "/images/store-v2/home-dashboard.webp",
    alt: "Approved store artwork showing your training dashboard and today's workout",
  },
  {
    step: 2,
    title: "Get a plan that adapts",
    description:
      "Follow a personalised workout schedule. Ask your coach for guidance when your training or schedule changes.",
    highlight: "Evolves with you",
    image: "/images/store-v2/weekly-plan.webp",
    alt: "Approved store artwork showing your weekly workout plan",
  },
  {
    step: 3,
    title: "See your progress",
    description:
      "Log your sets and sessions. See your training history and progress, then bring your questions to your coach.",
    highlight: "Progress you can see",
    image: "/images/store-v2/badge-journey.webp",
    alt: "Approved store artwork showing training milestones and your badge journey",
  },
];

const HowItWorks = () => {
  return (
    <section className="howitworks-section" id="how-it-works">
      <div className="container">
        <Reveal className="section-header">
          <h2 className="section-title">How It Works</h2>
          <p className="section-subtitle">
            Set your goals, get a personalised plan, and track your training.
          </p>
        </Reveal>

        <div className="chapters">
          {HOW_IT_WORKS.map((item, idx) => {
            const reverse = idx % 2 === 1;
            return (
              <div
                key={item.step}
                className={`chapter ${reverse ? "chapter-reverse" : ""}`}
              >
                <Reveal
                  className="chapter-copy"
                  variant={reverse ? "slide-right" : "slide-left"}
                >
                  <span className="chapter-number">
                    {String(item.step).padStart(2, "0")}
                  </span>
                  <span className="chapter-highlight">{item.highlight}</span>
                  <h3 className="chapter-title">{item.title}</h3>
                  <p className="chapter-description">{item.description}</p>
                </Reveal>
                <Reveal
                  className="chapter-visual"
                  variant={reverse ? "slide-left" : "slide-right"}
                  delay={120}
                >
                  <div className="chapter-phone">
                    <img src={item.image} alt={item.alt} width="660" height="1434" loading="lazy" />
                  </div>
                </Reveal>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
